import { UserPermissionService } from '@/domains/user/services/user-permission-service.interface';
import { injectService } from '@/inversify.config';
import { createSharedComposable } from '@vueuse/core';
import { computed, ref } from 'vue';
export const useUserPermission = createSharedComposable(() => {
    const userPermissionService = injectService(UserPermissionService);
    const _userPermission = ref(userPermissionService.userPermission);
    userPermissionService.subscribeUserPermission((newVal) => {
        _userPermission.value = newVal;
    });
    const userPermission = computed(() => {
        return _userPermission.value;
    });
    return {
        userPermission,
    };
});
